import { student_warning, editIcon, refresh_AI_Feedback_Icon } from "../../../../assets/images/images";
import PreprocessAndRenderLatex from "../../../../components/ProcessRenderLatex";
import { convertSecondsToMinutes, escapeHtmlEntities } from "../../../../utils/utlis";
import { processLatex } from "../../../../utils/PreProcessorLatexCode";
import AnswerInputView from "./AnswerInputView";
import MCQsView from "./MCQsView";
import api, { wsURL } from "../../../../api/api";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useAuth } from "../../../../features/auth/AuthContext";
import { marked } from "marked";
import Modal from '@mui/material/Modal'; // Using MUI Modal for simplicity
import { Tooltip } from "react-tooltip";
import { Box, Skeleton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getEditGrading, resetGrading } from "../../../../../src/state/actions/editGradingAction";
import csv_img from "../../../../assets/images/csv-file.png";
import file_img_storage from "../../../../assets/images/file-storage.png";
import png_svg from "../../../../assets/images/png-svg.svg";
import jpg_svg from "../../../../assets/images/jpg-svg.svg";
import doc_svg from "../../../../assets/images/doc-svg.svg";
import pdf_svg from "../../../../assets/images/pdf-svg.svg";
import txt_svg from "../../../../assets/images/txt-svg.svg";
import xls_svg from "../../../../assets/images/xls-svg.svg";
import svg_svg from "../../../../assets/images/svg-svg.svg";
import FilePreviewModal from "../../../../components/UploadDocument/FilePreviewModal";
import headphones2 from '../../../../assets/images/headphones2.svg';
import { normalizeLatexToDoubleDollar } from "../dashboard/teacher/lessons/NewLessons/utils/fileHelpers";
import { gl } from "date-fns/locale";
import { getAllCourseListByTeacher } from "../../../../state/actions/getAllCourseListByTeacherAction";

function QuestionNew({
  assignment,
  index,
  arrayIndex,
  currentStep,
  handleNext,
  handleBack,
  isLast,
  isFirst,
  close,
  totalSteps,
  ai_evaluation_json,
  questions,
  assignmentType,
  courseType,
  handleGetTeacherAnswerAssignmentAnalytics,
  analyticDetailsData,
  setAnalyticDetailsData,
  is_practice_assignment,
  getSubmissiondtls,
  accessControl,
  UserRoleRights,
  myRole,
  course_id,
  TeacherMyCourse,
  currentAssignment,
  wholeAssignment,
}) {





  const [loading, setLoading] = useState(false);

  const [editGradeMode, setEditGradeMode] = useState(false);
  const [getTeacherAnswer, setGetTeacherAnswer] = useState(null);
  const [disable, setDisable] = useState(false);
  const [feedbackText, setFeedbackText] = useState(questions?.[index]?.ai_feedback);
  const youtubeIframeRef = useRef(null);
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [timestamp, setTimestamp] = useState("");
  const imageSrc = assignment?.image || assignment?.picture_generation;
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);

  const globalState = useSelector((state) => state.globalState);
  const teacher_id = globalState?.teacher_details?.data?.teacher_id;
  const role = useSelector((state) => state?.globalState?.role);

  /* const allCourses = useSelector(
    (state) => state?.getAllCourseListByTeacher?.courses,
  ); */
  /* const TeacherMyCourse = allCourses?.some(
    (course) => Number(course?.course_id) === Number(course_id),
  ); */
  const editGrading = useSelector((state) => state.editGrading);

  const [isFilePreviewOpen, setIsFilePreviewOpen] = useState(false);
  const [previewFileIndex, setPreviewFileIndex] = useState(0);

  useEffect(() => {
    setFeedbackText(questions?.[index]?.ai_feedback || "");
  }, [index])

  useEffect(() => {
    if (editGrading.message === "Grade updated successfully.") {
      setEditGradeMode(false);
      dispatch(resetGrading());
      setDisable(false)
      toast.success(editGrading.message)

    }
  }, [editGrading]);

  useEffect(() => {
    return () => {
      dispatch(resetGrading());
      dispatch(
        getAllCourseListByTeacher(
          teacher_id,
          token
        )
      );
    }
  }, [])

  useEffect(() => {
    setIsImageLoaded(false);
    setImageFailed(false);
  }, [imageSrc]);

  const filesUploaded = assignment || []
  const allCourses = useSelector(
    (state) => state?.getAllCourseListByTeacher?.courses
  );

  const calculatedTeacherMyCourse = allCourses?.some(
    (course) => Number(course?.course_id) === Number(course_id)
  );

  const isTeacherMyCourse =
    TeacherMyCourse !== undefined
      ? TeacherMyCourse
      : calculatedTeacherMyCourse;

  function switchQuestionView() {
    // Check if there's only one file and it's a .webm audio file
    const hasOnlyWebmAudio = filesUploaded?.file_data?.length === 1 &&
      filesUploaded?.file_data[0]?.name?.toLowerCase().endsWith('.webm');
    switch (assignment?.type) {
      case "FITB":
        return <AnswerInputView value={assignment?.student_answer} />;

      case "MCQ":
        return (
          <MCQsView
            options={assignment?.options}
            student_answer={assignment?.student_answer}
            ai_answer={assignment?.ai_answer}
            editGradeMode={editGradeMode}
            setGetTeacherAnswer={setGetTeacherAnswer}
            getTeacherAnswer={getTeacherAnswer}
            loading={loading}
          />
        );
      case "TF":
        return (
          <MCQsView
            options={assignment?.options}
            student_answer={assignment?.student_answer}
            ai_answer={assignment?.ai_answer}
            editGradeMode={editGradeMode}
            setGetTeacherAnswer={setGetTeacherAnswer}
            getTeacherAnswer={getTeacherAnswer}
            loading={loading}
          />
        );
      default:
        return <AnswerInputView value={assignment?.student_answer || (hasOnlyWebmAudio ? "Answer submitted via recording." : "Answer submitted via document.")} />;

    }
  }
  const [isImagePopupOpen, setIsImagePopupOpen] = useState(false);
  const openImagePopup = () => setIsImagePopupOpen(true);
  const closeImagePopup = () => setIsImagePopupOpen(false);
  const { token } = useAuth();
  const dispatch = useDispatch();
  const [ws, setWs] = useState(null);

  const PHRASE_TRANSLATIONS = {
    "en": {
      "Correct": "Correct",
      "Incorrect": "Incorrect",
      "Partial Credit": "Partial Credit",
    },
    "es": {
      "Correct": "Correcto",
      "Incorrect": "Incorrecto",
      "Partial Credit": "Crédito Parcial",
    },
    "fr": {
      "Correct": "Correct",
      "Incorrect": "Incorrect",
      "Partial Credit": "Crédit Partiel",
    },
    "de": {
      "Correct": "Richtig",
      "Incorrect": "Falsch",
      "Partial Credit": "Teilweise Richtig",
    },
    "it": {
      "Correct": "Corretto",
      "Incorrect": "Sbagliato",
      "Partial Credit": "Credito Parziale",
    },
    "pt": {
      "Correct": "Correto",
      "Incorrect": "Incorreto",
      "Partial Credit": "Crédito Parcial",
    },
    "ru": {
      "Correct": "Верно",
      "Incorrect": "Неверно",
      "Partial Credit": "Частично Верно",
    },
    "zh": {
      "Correct": "正确",
      "Incorrect": "错误",
      "Partial Credit": "部分正确",
    },
    "ja": {
      "Correct": "正解",
      "Incorrect": "不正解",
      "Partial Credit": "部分的に正解",
    },
    "ko": {
      "Correct": "정확함",
      "Incorrect": "부정확함",
      "Partial Credit": "부분 점수",
    },
    "ar": {
      "Correct": "صحيح",
      "Incorrect": "غير صحيح",
      "Partial Credit": "صحيح جزئيًا",
    },
    "hi": {
      "Correct": "सही",
      "Incorrect": "गलत",
      "Partial Credit": "आंशिक अंक",
    },
    "bn": {
      "Correct": "সঠিক",
      "Incorrect": "ভুল",
      "Partial Credit": "আংশিক ক্রেডিট",
    },
    "tr": {
      "Correct": "Doğru",
      "Incorrect": "Yanlış",
      "Partial Credit": "Kısmi Kredi",
    },
    "nl": {
      "Correct": "Juist",
      "Incorrect": "Onjuist",
      "Partial Credit": "Gedeeltelijk Juist",
    },
    "pl": {
      "Correct": "Poprawne",
      "Incorrect": "Niepoprawne",
      "Partial Credit": "Częściowy Kredyt",
    },
    "vi": {
      "Correct": "Chính xác",
      "Incorrect": "Không chính xác",
      "Partial Credit": "Điểm một phần",
    },
    "th": {
      "Correct": "ถูกต้อง",
      "Incorrect": "ไม่ถูกต้อง",
      "Partial Credit": "ถูกต้องบางส่วน",
    },
    "ur": {
      "Correct": "درست",
      "Incorrect": "غلط",
      "Partial Credit": "جزوی کریڈٹ",
    },
    "sv": {
      "Correct": "Korrekt",
      "Incorrect": "Felaktigt",
      "Partial Credit": "Delvis Korrekt",
    },
    "id": {
      "Correct": "Betul",
      "Incorrect": "Salah",
      "Partial Credit": "Sebahagian Betul",
    },
    "fi": {
      "Correct": "Oikein",
      "Incorrect": "Väärin",
      "Partial Credit": "Osittain Oikein",
    },
    "uk": {
      "Correct": "Правильно",
      "Incorrect": "Неправильно",
      "Partial Credit": "Частково Правильно",
    },
    "el": {
      "Correct": "Σωστό",
      "Incorrect": "Λάθος",
      "Partial Credit": "Μερικώς Σωστό",
    },
    "cs": {
      "Correct": "Správně",
      "Incorrect": "Nesprávně",
      "Partial Credit": "Částečně Správně",
    },
    "he": {
      "Correct": "נכון",
      "Incorrect": "שגוי",
      "Partial Credit": "נכון חלקית",
    },
    "ro": {
      "Correct": "Corect",
      "Incorrect": "Incorect",
      "Partial Credit": "Parțial Corect",
    },
    "hu": {
      "Correct": "Helyes",
      "Incorrect": "Helytelen",
      "Partial Credit": "Részben Helyes",
    },
    "da": {
      "Correct": "Korrekt",
      "Incorrect": "Forkert",
      "Partial Credit": "Delvist Korrekt",
    },
    "no": {
      "Correct": "Riktig",
      "Incorrect": "Feil",
      "Partial Credit": "Delvis Riktig",
    },
    "sk": {
      "Correct": "Správne",
      "Incorrect": "Nesprávne",
      "Partial Credit": "Čiastočne Správne",
    },
    "ms": {
      "Correct": "Betul",
      "Incorrect": "Salah",
      "Partial Credit": "Sebahagian Betul",
    },
    "la": {
      "Correct": "Rectum",
      "Incorrect": "Incorrectum",
      "Partial Credit": "Credita Partialia",
    }
  }

  // This is the part of your code where you are setting the color based on the evaluation result.
  const language = ai_evaluation_json?.language || "en"; // Default to "en" if no language is provided
  const evaluation = ai_evaluation_json?.questions[index]?.evaluation || ""; // Get the evaluation for the question

  // Fetch the translated phrase based on the language
  const translatedEvaluation = PHRASE_TRANSLATIONS[language][evaluation] || evaluation;

  // Set the colors based on the translated evaluation
  let textColor = "";
  let backgroundColor = "";

  switch (translatedEvaluation) {
    case PHRASE_TRANSLATIONS[language]['Correct']:
      textColor = "#28991f";
      backgroundColor = "#e6ffe5";
      break;
    case PHRASE_TRANSLATIONS[language]['Incorrect']:
      textColor = "#b24747";
      backgroundColor = "#ffd6d6";
      break;
    case PHRASE_TRANSLATIONS[language]['Partial Credit']:
      textColor = "#FFA800";
      backgroundColor = "#FFE5CC";
      break;
    default:
      // Default to neutral colors if evaluation doesn't match
      textColor = "#000"; // Black
      backgroundColor = "#fff"; // White
      break;
  }

  const [isScoreEditPopup, setIsScoreEditPopup] = useState(false);
  const [getTeacherAnswerText, setGetTeacherAnswerText] = useState('');

  // Ref for click outside detection
  const statusEditableWrapperRef = useRef(null);

  useEffect(() => {
    if (!isScoreEditPopup) return;
    function handleClickOutside(event) {
      if (
        statusEditableWrapperRef.current &&
        !statusEditableWrapperRef.current.contains(event.target)
      ) {
        setIsScoreEditPopup(false);
        setGetTeacherAnswerText('');
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isScoreEditPopup]);

  useEffect(() => {
    if (currentAssignment?.youtube_url) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(
        currentAssignment.youtube_url,
        "text/html"
      );
      const iframe = doc.querySelector("iframe");
      if (iframe) {
        setYoutubeUrl(iframe.getAttribute("src"));
      } else {
        setYoutubeUrl("");
      }
    } else {
      setYoutubeUrl("");
    }

    if (currentAssignment?.youtube_timestamp) {
      const doc = new DOMParser().parseFromString(
        currentAssignment.youtube_timestamp,
        "text/html"
      );
      const buttonText = doc.querySelector("button")?.textContent || "";
      setTimestamp(buttonText || "");
    } else {
      setTimestamp("");
    }
  }, [currentAssignment]);


  // "06:37" -> 397 , "1:02:03" -> 3723 , "397" -> 397
  function timestampToSeconds(text) {
    if (!text) return 0;
    const clean = String(text).trim();
    if (/^\d+$/.test(clean)) return parseInt(clean, 10);
    const parts = clean.split(":").map((p) => parseInt(p, 10));
    if (parts.some((p) => Number.isNaN(p))) return 0;
    if (parts.length === 2) return parts[0] * 60 + parts[1];
    if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
    return 0;
  }

  function seekYoutube(iframe, seconds) {
    if (!iframe || !iframe.contentWindow) return false;
    const post = (func, args = []) =>
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: "command", func, args }),
        "https://www.youtube.com"
      );
    try {
      post("seekTo", [seconds, true]);
      post("playVideo");
      return true;
    } catch (e) {
      console.error("seekYoutube postMessage failed:", e);
      return false;
    }
  }

  const youtubeEmbedSrc = useMemo(() => {
    if (!youtubeUrl) return "";
    try {
      const url = new URL(youtubeUrl);
      url.searchParams.set("enablejsapi", "1");
      return url.toString();
    } catch {
      return youtubeUrl;
    }
  }, [youtubeUrl]);

  const handleTimestampClick = () => {
    const seconds = timestampToSeconds(timestamp);
    const iframe = youtubeIframeRef.current;

    const ok = seekYoutube(iframe, seconds);

    // fallback: reload src at timestamp with autoplay if player not ready
    if (!ok && iframe) {
      try {
        const url = new URL(iframe.src);
        url.searchParams.set("start", String(seconds));
        url.searchParams.set("autoplay", "1");
        iframe.src = url.toString();
      } catch (e) {
        console.error("timestamp reload fallback failed:", e);
      }
    }

    iframe?.scrollIntoView({ behavior: "smooth", block: "center" });
  };



  const handleTecherMarks = () => {
    let error = null

    if (getTeacherAnswerText === '') {
      error = "Please enter marks";
    } else if (assignmentType === 'FITB') {
      if ((Number(getTeacherAnswerText) !== 0 && Number(getTeacherAnswerText) !== ai_evaluation_json?.questions[index]?.marks) || /^0{2,}$/.test(getTeacherAnswerText)) {
        error = 'Please enter 0 or the total marks for FITB questions';
      }
    } else if (getTeacherAnswerText === Math.abs(getTeacherAnswerText)) {
      error = "please enter positive number"
    } else if (Number(getTeacherAnswerText) > ai_evaluation_json?.questions[index]?.marks) {
      error = "Marks cannot be greater than total marks";
    } else if (/^0{2,}$/.test(getTeacherAnswerText)) {
      error = "Please enter a valid number";
    }

    if (error) {
      toast.error(error, {
        position: "top-center",
      });
      return;
    }

    handleGetTeacherAnswerAssignmentAnalytics(null, null, assignmentType, getTeacherAnswerText, 'Save-For-Student');
    setIsScoreEditPopup(false);

    setGetTeacherAnswerText('');

  }


  const handleChangeMarks = (e) => {
    setGetTeacherAnswerText(e.target.value);
  }

  const editGrade = () => {

    if (assignmentType === 'MCQ' || assignmentType === 'True/False' || assignmentType === 'TF' || globalState?.role === "Student" || loading) return;
    setIsScoreEditPopup(true)

    setEditGradeMode(false)
  }


  const [reformatterReconnectAttempts, setReformatterReconnectAttempts] = useState(0);
  const isIntentionalCloseRef = useRef(false);


  let combinedMessage = []; // ✅ Buffer to hold incoming messages

  const handleRefreshAI = () => {
    setLoading(true); // Start loader for new data
    // Construct the WebSocket URL with the provided parameters
    const newWebSocketURL = `${wsURL}ws/ai-feedback/?course_id=538385&teacher_id=558479&token=${token}`;


    let reconnectInterval = 1000;
    const maxReconnectInterval = 30000;
    const reconnectDecay = 1.5;
    const maxReconnectAttempts = 5;

    let socket = new WebSocket(newWebSocketURL);
    // 

    socket.onopen = () => {
      console.log("Reformatter WebSocket connection opened");
      setReformatterReconnectAttempts(0);
      isIntentionalCloseRef.current = false; // Reset intentional close flag
      reconnectInterval = 1000;

      const payload = {
        "question_id": assignment?.question_id,
        "submission_id": analyticDetailsData?.submission_id,
        "selected_answer": (assignmentType === "MCQ" || assignmentType === "True/False" || assignmentType === "TF") ? getTeacherAnswer : assignment?.student_answer,
        "ai_feedback": questions[index]?.ai_feedback,
        "question_type": assignmentType,
        "marks": ai_evaluation_json?.questions[index]?.marks_obtained,
        "language": ai_evaluation_json?.language,
        "total_marks": ai_evaluation_json?.questions[index]?.marks,
        "question_text": assignment?.question
      }

      // **Send the payload once WebSocket is open**
      if (payload) {
        const payloadJSON = JSON.stringify(payload);
        localStorage.setItem('refreshFeedbackPayload', payloadJSON); // Store payload in localStorage
        socket.send(payloadJSON);
      }
    };



    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        if (data && data.message) {
          const message = data.message;


          // ✅ Clear old messages when a new response starts
          if (message.includes("<STARTOFTURN>")) {
            combinedMessage.length = 0; // Reset buffer here
          }

          // combinedMessage.push(message === "AI feedback generated successfully" ? data.ai_feedback : );
          combinedMessage.push(message);
          let chatdatares = combinedMessage.join("");

          // ✅ Remove STARTOFTURN and ENDOFTURN tags
          chatdatares = chatdatares
            .replace(/<STARTOFTURN>/g, "")
            .replace(/<ENDOFTURN>/g, "");

          // ✅ Stop loader when actual data is received
          if (chatdatares.trim() !== "") {
            // setLoading(false);
          }

          if (message === 'AI feedback generated successfully') {

            let currentText = "";
            let index = 0;

            const interval = setInterval(() => {
              currentText += data.ai_feedback[index];
              setFeedbackText(currentText);
              index++;

              if (index === data.ai_feedback.length) {
                clearInterval(interval); // Stop when all characters are processed
              }
            }, 5); // Adjust the interval for the desired speed of character appearance


            setLoading(false);

            console.log("Received ENDOFTURN, closing socket intentionally");
            isIntentionalCloseRef.current = true; // Mark as intentional close
            combinedMessage.length = 0; // Clear buffer here
            combinedMessage.push(chatdatares);
            socket.close();
          }

          // setFormErrors((prevErrors) => ({ ...prevErrors, description: "" }));
        }
      } catch (error) {
        console.error("Error processing WebSocket message:", error);
        setLoading(false);
      }
    };

    socket.onclose = () => {
      setLoading(false);

      console.log("Socket closed, isIntentionalCloseRef.current:", isIntentionalCloseRef.current);
      // Only reconnect if it wasn't an intentional close
      if (!isIntentionalCloseRef.current && reformatterReconnectAttempts < maxReconnectAttempts) {
        setTimeout(() => {
          setReformatterReconnectAttempts((prev) => prev + 1);
          reconnectInterval = Math.min(reconnectInterval * reconnectDecay, maxReconnectInterval);
          console.log(`Reformatter Reconnecting... Attempt ${reformatterReconnectAttempts + 1}`);
          handleRefreshAI();
        }, reconnectInterval);
      } else {
        console.log("WebSocket closed, but no reconnection needed.");
        // Reset the intentional close flag for next connection
        isIntentionalCloseRef.current = false;
      }
    };

    socket.onerror = (error) => {
      setLoading(false);

      console.error("Reformatter WebSocket error:", error);
      socket.close();
    };
  };


  const handleEditGrade = () => {
    setEditGradeMode(true);
  }

  const handleCancelEdit = () => {
    setEditGradeMode(false)
    setGetTeacherAnswer(null);
    setFeedbackText(questions[index]?.ai_feedback)
  }

  const handleSaveBTN = (saveStatues) => {
    if (!feedbackText.trim()) {
      toast.error("Please provide feedback text before saving.");
      return;
    }



    handleGetTeacherAnswerAssignmentAnalytics(getTeacherAnswer, feedbackText.replace(/\s+/g, ' ').trim(), assignmentType, null, saveStatues);
    setGetTeacherAnswer(null);
    setDisable(true);
  }

  const handleChangeFeedbackText = (e) => {
    setFeedbackText(e.target.value);
  }

  // Helper variables for button state and style
  const isMCQType = assignmentType === 'MCQ' || assignmentType === 'True/False' || assignmentType === 'TF';
  const isSaveDisabled = isMCQType && !getTeacherAnswer;

  const saveForStudentBtnStyle = loading || disable || (isMCQType ? ((feedbackText === questions?.[index]?.ai_feedback) && !getTeacherAnswer) : (feedbackText === questions?.[index]?.ai_feedback))
    ? { color: '#B3B3B3', border: '1px solid #B3B3B3', cursor: 'default' }
    : {};

  const saveForAllBtnStyle = loading || disable || (isMCQType ? ((feedbackText === questions?.[index]?.ai_feedback) && !getTeacherAnswer) : (feedbackText === questions?.[index]?.ai_feedback))
    ? { color: 'white', backgroundColor: '#B3B3B3', border: '1px solid #B3B3B3', cursor: 'default' }
    : {};

  // Helper variables for readability
  const showTeacherAnswer = getTeacherAnswer;
  const showEditGrade = editGradeMode;
  const aiFeedback = questions && questions?.[index]?.ai_feedback || " ";


  const feedbackContent = aiFeedback;
  const feedbackContentEscaped = aiFeedback;


  // Helper functions for rendering
  function renderFeedbackTextarea() {
    return (
      <textarea
        type="text"
        rows="8"
        cols="5"
        className="textarea-for-ai-feedback"
        value={feedbackText}
        onChange={handleChangeFeedbackText}
        disabled={loading}
        style={{ backgroundColor: editGradeMode ? 'white' : '#F5F5F5' }}
      />
    );
  }

  function renderFeedbackDisplay(content) {
    return (
      <p>
        <PreprocessAndRenderLatex
          content={normalizeLatexToDoubleDollar(content)}
          latexInline={true}
          isBlockMath={false}
        />
      </p>
    );
  }

  // Add this function after your other helper functions, before getFileIcon
  const getFileTypeFromName = (filename) => {
    if (!filename) return '';

    const extension = filename.split('.').pop().toLowerCase();

    const typeMap = {
      // Images
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'svg': 'image/svg+xml',

      // Documents
      'pdf': 'application/pdf',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'txt': 'text/plain',

      // Spreadsheets
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'csv': 'text/csv',

      // Audio
      'mp3': 'audio/mpeg',
      'wav': 'audio/wav',
      'webm': 'audio/webm',
    };

    return typeMap[extension] || 'application/octet-stream';
  };

  const XIcon = () => (
    <svg style={{ width: '100%', height: '100%' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  );

  const PlusIcon = () => (
    <svg style={{ width: '24px', height: '24px', color: '#999' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
  );

  const PngIcon = () => (
    <img src={png_svg} alt="PNG" style={{ width: '20px', height: '20px', }} />
  );

  const JpgIcon = () => (
    <img src={jpg_svg} alt="JPG" style={{ width: '20px', height: '20px', }} />
  );

  const FileDocIcon = () => (
    <img src={doc_svg} alt="DOC" style={{ width: '20px', height: '20px', }} />

  );

  const FileXlsIcon = () => (
    <img src={xls_svg} alt="XLS" style={{ width: '20px', height: '20px', }} />

  );

  const FileCsvIcon = () => (
    <img src={csv_img} alt="CSV" style={{ width: '20px', height: '20px', }} />

  );

  const MusicIcon = () => (
    <img src={headphones2} alt="MUSIC" />
  );

  const FileIcon = () => (
    <svg style={{ width: '20px', height: '20px', color: '#6c757d' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  );

  const FilePdfIcon = () => (
    <img src={pdf_svg} alt="PDF" style={{ width: '20px', height: '20px', }} />
  );


  const TxtIcon = () => (
    <img src={txt_svg} alt="TXT" style={{ width: '20px', height: '20px', }} />
  );

  const FileSvgIcon = () => (
    <img src={svg_svg} alt="SVG" style={{ width: '20px', height: '20px', }} />
  );

  const FileStorageIcon = () => (
    <img src={file_img_storage} alt="File Storage" style={{ width: '20px', height: '20px', }} />
  );

  const getFileIcon = (fileType, fileName) => {


    const type = fileType || getFileTypeFromName(fileName);

    // Check if type is a valid string
    if (!type || typeof type !== 'string') {
      return <FileStorageIcon />;
    }

    if (type.includes('png')) return <PngIcon />;
    if (type === 'text/plain') return <TxtIcon />;
    if (type.includes('jpg') || type.includes('jpeg')) return <JpgIcon />;
    if (type.includes('pdf')) return <FilePdfIcon />;
    if (type.includes('xls') || type.includes('xlsx') || type.includes('spreadsheet')) return <FileXlsIcon />;
    if (type.includes('csv')) return <FileCsvIcon />;
    if (type.includes('svg')) return <FileSvgIcon />;
    if (type.includes('word') || type.includes('document')) return <FileDocIcon />;
    if (type.startsWith('audio/')) return <MusicIcon />;
    return <FileStorageIcon />;
  };



  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };








  const openFilePreview = (index) => {

    setPreviewFileIndex(index);
    setIsFilePreviewOpen(true);
  };

  const pauseYoutube = () => {
    try {
      youtubeIframeRef.current?.contentWindow?.postMessage(
        JSON.stringify({ event: "command", func: "pauseVideo", args: [] }),
        "https://www.youtube.com"
      );
    } catch (e) { /* iframe not ready */ }
  };

  const closeFilePreview = () => {
    setIsFilePreviewOpen(false);
  };
  return (
    <>

      <div className="AssignmentViewProgress-mock-test-status-container">
        <div className="AssignmentViewProgress-mock-test-marks-obtained">
          <div className="AssignmentViewProgress-mock-test-status-editable-wrapper"
            ref={statusEditableWrapperRef}
            style={{
              cursor: assignmentType === 'MCQ' || assignmentType === 'True/False' || assignmentType === 'TF' || globalState?.role === 'Student' || loading ? 'default' : 'pointer'
            }}
          >
            <div className="AssignmentViewProgress-mock-test-status-folder" onClick={(isTeacherMyCourse || role === "Admin") && ((isTeacherMyCourse || role === "Admin") && myRole !== "viewer") ? editGrade : undefined} >
              {(isTeacherMyCourse || role === "Admin") && ((isTeacherMyCourse || role === "Admin") && myRole !== "viewer") && (
                !isScoreEditPopup && !isMCQType && role !== "Student" &&
                <img src={editIcon} alt="edit icon" />
              )}
              <p>Score</p>
              <div
                className={`AssignmentViewProgress-mock-test-status-correction ${translatedEvaluation}`}
                style={{
                  color: isScoreEditPopup ? 'black' : textColor,
                  backgroundColor: isScoreEditPopup ? '#EFEFEF' : backgroundColor,
                }}
              >
                {
                  isScoreEditPopup ? <span >
                    <input type="number" style={{
                      width: '31px',
                      borderColor: "transparent",
                      backgroundColor: '#EFEFEF'
                    }}
                      value={getTeacherAnswerText}
                      onChange={handleChangeMarks}
                      onKeyDown={(e) => {
                        const invalidChars = ['-', '+', 'e', 'E'];
                        if (invalidChars.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />/
                    {ai_evaluation_json?.questions[index]?.marks}
                  </span> :
                    <span>
                      {ai_evaluation_json?.questions[index]?.marks_obtained}/
                      {ai_evaluation_json?.questions[index]?.marks}
                    </span>
                }

              </div>
            </div>

            {
              ((isTeacherMyCourse || role === "Admin") && isScoreEditPopup) && <div className="AssignmentViewProgress-mock-test-status-editable-btn" >
                <button
                  onClick={handleTecherMarks}
                ><img src={editIcon} alt="Save Score" />Save Score</button>
              </div>
            }
          </div>



          <div className="AssignmentViewProgress-mock-test-status-duration-folder">
            <p>Duration :</p>
            <div className="AssignmentViewProgress-mock-test-status-time-duration">
              <p>{convertSecondsToMinutes(assignment?.time_taken)}</p>
            </div>
          </div>
          {
            (editGrading.isLoading) && <>
              <div className="verifying-answer-spinner-wrapper">
                <div className="verifying-answer-spinner">
                  <div class="spinner-box">
                    <div class="circle-border">
                      <div class="circle-core"></div>
                    </div>
                  </div>
                </div>
                <div id="Animation-front">
                  <b className="Animation-front-container">
                    <span>
                      &nbsp;Verifying Answer...<br />
                      &nbsp;Updating Score...<br />
                    </span>
                  </b>
                </div>
              </div>
            </>
          }
        </div>
        {
          ((isTeacherMyCourse || role === "Admin") && myRole !== "viewer") &&
          <button type="button" className="edit-grade" onClick={handleEditGrade}
            style={{
              cursor: editGradeMode && 'default',
            }}
          >
            <img src={editIcon} alt="edit icon" />
            <p
              style={{
                color: editGradeMode && '#B3B3B3',
              }}
            >Edit Grade</p>
          </button>
        }


        {close}
      </div >

      {/* {timestamp !== "" &&
        (!wholeAssignment || wholeAssignment.lesson_preview) && ( */}
      {/* {(youtubeEmbedSrc !== "" || assignment?.image || assignment?.picture_generation) && ( */}
      {(((youtubeEmbedSrc !== "") || (imageSrc && !imageFailed)) && (!wholeAssignment || wholeAssignment.lesson_preview)) && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "20px",
            flexWrap: "wrap", // stacks on small screens
          }}
          className="my-[20px] [@media(max-height:839px)]:my-0"
        >
          {youtubeEmbedSrc !== "" && (
            <iframe
              ref={youtubeIframeRef}
              className="
          w-[460px] h-[245px]
          [@media(max-height:729px)]:w-[360px]
          [@media(max-height:729px)]:h-[190px]
          [@media(max-width:767px)]:w-[270px]
          [@media(max-width:767px)]:h-[170px]
        "
              src={youtubeEmbedSrc}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          )}

          {/* {(assignment?.image || assignment?.picture_generation) && (
            <div
              style={{ width: "auto", height: "160px", cursor: "pointer" }}
              className="assignment-graph-image
          [@media(max-height:729px)]:h-[140px]
          [@media(max-width:767px)]:h-[120px]"
              data-tooltip-id="Click_here_to_preview_image"
            >
              <img
                src={assignment?.image || assignment?.picture_generation}
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
                onClick={openImagePopup}
              />
              <Tooltip
                id="Click_here_to_preview_image"
                place="top"
                content="Click here to preview image"
                type="light"
                effect="float"
              />
            </div>
          )} */}

          {imageSrc && !imageFailed && (
            <div
              style={{
                width: isImageLoaded ? "auto" : "220px",
                height: "160px",
                cursor: isImageLoaded ? "pointer" : "default",
                position: "relative",
              }}
              className="assignment-graph-image
      [@media(max-height:729px)]:h-[140px]
      [@media(max-width:767px)]:h-[120px]"
              data-tooltip-id={isImageLoaded ? "Click_here_to_preview_image" : undefined}
            >
              {!isImageLoaded && (
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  sx={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    borderRadius: "8px",
                    bgcolor: "#EFEFEF",
                  }}
                />
              )}

              <img
                // src change must remount so a cached image can't skip onLoad
                key={imageSrc}
                src={imageSrc}
                alt=""
                // ref callback covers the cached case: `complete` is already true
                // before React attaches onLoad, so onLoad never fires
                ref={(node) => {
                  if (node?.complete && node.naturalWidth > 0) setIsImageLoaded(true);
                }}
                onLoad={() => setIsImageLoaded(true)}
                onError={() => {
                  console.error("Question image failed to load:", imageSrc);
                  setImageFailed(true);
                }}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  opacity: isImageLoaded ? 1 : 0,
                  transition: "opacity 0.2s ease",
                }}
                onClick={isImageLoaded ? openImagePopup : undefined}
              />

              {isImageLoaded && (
                <Tooltip
                  id="Click_here_to_preview_image"
                  place="top"
                  content="Click here to preview image"
                  type="light"
                  effect="float"
                />
              )}
            </div>
          )}

        </div>
      )}

      <div className="AssingmentMCQs-mock-test-question-answer-container">
        <div className="view-result-submition-AssingmentMCQs-scroller">
          <h2>
            <div className="AssingmentMCQs-mock-test-question-folder">
              <span className="AssingmentMCQs-question">Q. {index + 1} :</span>
              <span className="AssingmentMCQs-answers">
                {
                  courseType === 2 ?
                    <PreprocessAndRenderLatex
                      content={normalizeLatexToDoubleDollar(assignmentType === 'MIX' ?
                        (`${assignment?.question} (${assignment?.type === 'TF' ? 'T/F' : assignment?.type})`) :
                        assignment?.question
                      )}
                      latexInline={true}
                    /> :
                    <PreprocessAndRenderLatex
                      content={normalizeLatexToDoubleDollar(assignmentType === 'MIX' ?
                        (`${assignment?.question} (${assignment?.type === 'TF' ? 'T/F' : assignment?.type})`) :
                        assignment?.question
                      )}
                      latexInline={true}
                    />
                }

                {
                  timestamp !== "" &&
                  (!wholeAssignment || wholeAssignment.lesson_preview) && (
                  // timestamp !== "" && (
                    <button
                      type="button"
                      className="youtube_timestamp"
                      onClick={handleTimestampClick}
                    >
                      {timestamp}
                    </button>
                  )
                }
              </span>
            </div>
            {/* {assignment?.image || assignment?.picture_generation  && (
              <div style={{ width: "auto", height: "160px", cursor: "pointer" }} className="assignment-graph-image"
                data-tooltip-id="Click_here_to_preview_image"
              >
                <img
                  src={assignment?.image || assignment?.picture_generation}
                  // alt={`Question ${index + 1} Illustration`}
                  style={{ width: "100%", height: "100%" }}
                  onClick={openImagePopup}
                />
                <Tooltip
                  id="Click_here_to_preview_image"
                  place="top"
                  content="Click here to preview image"
                  type="light"
                  effect="float"
                />
              </div>
            )} */}
          </h2>
          {courseType === 2 ? (
            <div className="AssingmentMCQs-answer-side-by-sideb-folder">
              {switchQuestionView()}
              <div className="AssingmentMCQs-mock-test-Ai-feedback-wrapper">
                <h2 className="AssingmentMCQs-mock-test-title">AI Feedback</h2>
                <div className="AssingmentMCQs-mock-test-Ai-feedback-answer" style={{ backgroundColor: editGradeMode ? 'white' : '#F5F5F5', borderRadius: '6px', boxShadow: "0px 1px 5px #e2e2e2" }}>
                  {(showEditGrade
                    ? renderFeedbackTextarea()
                    : renderFeedbackDisplay(feedbackContent))
                  }
                  {isMCQType
                    ? showTeacherAnswer && (
                      <div className="AssingmentMCQs-mock-test-refresh-ai-feedback-btn">
                        <button type="button" onClick={handleRefreshAI} disabled={loading}>
                          {loading ? 'Updating...' : 'Refresh AI Feedback'} <img src={refresh_AI_Feedback_Icon} alt="refresh AI Feedback Icon" className={loading ? "rotating" : ""} />
                        </button>
                      </div>
                    )
                    : showEditGrade && (
                      <div className="AssingmentMCQs-mock-test-refresh-ai-feedback-btn">
                        <button type="button" onClick={handleRefreshAI} disabled={loading}>
                          {loading ? 'Updating...' : 'Refresh AI Feedback'} <img src={refresh_AI_Feedback_Icon} alt="refresh AI Feedback Icon" className={loading ? "rotating" : ""} />
                        </button>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="AssingmentMCQs-answer-side-by-sideb-folder">
                {switchQuestionView()}
                <div className="AssingmentMCQs-mock-test-Ai-feedback-wrapper">
                  <h2 className="AssingmentMCQs-mock-test-title">AI Feedback</h2>
                  <div className="AssingmentMCQs-mock-test-Ai-feedback-answer" style={{ backgroundColor: editGradeMode ? 'white' : '#F5F5F5', borderRadius: '6px', boxShadow: "0px 1px 5px #e2e2e2" }}>
                    {(showEditGrade
                      ? renderFeedbackTextarea()
                      : renderFeedbackDisplay(feedbackContentEscaped))
                    }
                    {isMCQType
                      ? showTeacherAnswer && (
                        <div className="AssingmentMCQs-mock-test-refresh-ai-feedback-btn">
                          <button type="button" onClick={handleRefreshAI} disabled={loading}>
                            {loading ? 'Updating...' : 'Refresh AI Feedback'} <img src={refresh_AI_Feedback_Icon} alt="refresh AI Feedback Icon" className={loading ? "rotating" : ""} />
                          </button>
                        </div>
                      )
                      : showEditGrade && (
                        <div className="AssingmentMCQs-mock-test-refresh-ai-feedback-btn">
                          <button type="button" onClick={handleRefreshAI} disabled={loading}>
                            {loading ? 'Updating...' : 'Refresh AI Feedback'} <img src={refresh_AI_Feedback_Icon} alt="refresh AI Feedback Icon" className={loading ? "rotating" : ""} />
                          </button>
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="AssingmentMCQs-mock-test-answer-files">
          {filesUploaded?.file_data?.length > 0 && (
            <>
              <div className='uploaded-files-list' style={{ fontSize: '12px', color: '#000', fontWeight: '600', marginBottom: '8px' }}>
                FILES
              </div>

              <div className='uploaded-files-container'>
                {filesUploaded?.file_data?.map((file, fileIndex) => (
                  <div
                    className='uploaded-file-item'
                    key={`${index}-${fileIndex}`}
                    onClick={() => openFilePreview(fileIndex)}
                    style={{ cursor: 'pointer' }}
                    title={file?.name}
                  >
                    <div className='uploaded-file-icon' style={{ borderRadius: "50%", backgroundColor: "#f0f0f0" }}>{getFileIcon(file.type, file.name)}</div>
                    <div className='uploaded-file-info'>
                      <span style={{
                        fontSize: '12px',
                        color: '#000',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '90px',
                        fontWeight: '400'
                      }}>
                        {file?.name}
                      </span>

                      <div className="AssingmentMCQs-mock-test-answer-file-size" style={{ fontSize: '10px', color: '#9ca3af' }}>
                        {file?.size}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <FilePreviewModal
                isOpen={isFilePreviewOpen}
                files={filesUploaded?.file_data || []}
                initialIndex={previewFileIndex}
                onClose={closeFilePreview}
                getFileIcon={getFileIcon}
              />
            </>
          )}
        </div>

        {
          !editGradeMode ?
            <div className="AssingmentMCQs-mock-test-answer-btn-folder">
              {(
                <button
                  onClick={() => {
                    handleBack();
                    pauseYoutube();
                  }}
                  disabled={isFirst}
                  className="AssingmentMCQs-mock-test-back-btn"
                  style={{
                    cursor: isFirst ? 'not-allowed' : 'pointer',
                  }}>
                  <span
                    className="AssingmentMCQs-mock-test-answer-left-arrow-btn"
                    style={{
                      color: isFirst ? '#a9a9a9' : '',
                    }}>
                    <i className="fa-solid fa-arrow-left"
                      style={{
                        color: isFirst ? '#a9a9a9' : '',
                      }}></i>
                  </span>
                  <span
                    style={{
                      color: isFirst ? '#a9a9a9' : '',
                    }}
                  >
                    Back
                  </span>
                </button>
              )}
              <div className="pagination">
                <span>
                  {currentStep} / {totalSteps}
                </span>
              </div>
              {!isLast && (
                <button
                  disabled={isLast}
                  onClick={() => {
                    handleNext();
                    pauseYoutube();
                  }}
                  className="AssingmentMCQs-mock-test-next-btn">
                  {isLast ? "" : "Next"}
                  <span className="AssingmentMCQs-mock-test-answer-right-arrow-btn">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              )}
            </div> :
            <div className="AssingmentMCQs-mock-test-answer-btn-save-all-folder">
              <button type="button" className="cancel" disabled={loading} style={{ cursor: loading && 'not-allowed' }} onClick={() => handleCancelEdit()}>Cancel</button>
              <div className="AssingmentMCQs-mock-test-answer-btn-save-for-all">
                <button
                  type="button"
                  disabled={loading || disable || (isMCQType ? ((feedbackText === questions[index]?.ai_feedback) && !getTeacherAnswer) : (feedbackText === questions[index]?.ai_feedback))}
                  style={saveForStudentBtnStyle}
                  onClick={() => { handleSaveBTN('Save-For-Student') }}
                >
                  Save For Student
                </button>
                {
                  !is_practice_assignment &&
                  <button
                    type="button"
                    disabled={loading || disable || (isMCQType ? ((feedbackText === questions[index]?.ai_feedback) && !getTeacherAnswer) : (feedbackText === questions[index]?.ai_feedback))}
                    style={saveForAllBtnStyle}
                    onClick={() => { handleSaveBTN('Save-For-All') }}
                  >
                    Save For All
                  </button>
                }
              </div>
            </div>
        }
      </div >

      <Modal
        open={isImagePopupOpen}
        onClose={closeImagePopup}
        aria-labelledby="image-popup"
        aria-describedby="popup-showing-full-image"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          outline: 'none',
        }}
      >
        <div
          onClick={closeImagePopup}
          style={{
            width: '50%', // Increased width to 90%
            // maxWidth: '800px', // Optional: prevent the image from becoming too large
            height: '50%', // Increased height to 90%
            // maxHeight: '85vh', // Optional: adjust for screen size
            outline: 'none',
            cursor: 'pointer',
            overflow: 'hidden', // Prevent image overflow
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={assignment?.image || assignment?.picture_generation}
            alt={`Full Question ${index + 1} Illustration`}
            style={{
              width: '100%',
              height: '100%', // Maintain aspect ratio
              objectFit: 'contain', // Fit the image within the container without distortion
              borderRadius: '8px',
            }}
          />
        </div>
      </Modal>

    </>
  );
}

export default QuestionNew;